module.exports = __webpack_public_path__ + "static/media/sudoku.d5da22c7.png";